import React, { useState, useEffect, useCallback } from "react";

const STEPS = [
  {
    target: ".stack-container",
    text: "This is the type of man that will approach you in SF. Swipe to accept or reject him. He will talk to you whether you like it or not.",
    position: "right",
  },
  {
    target: ".reject-btn",
    text: "Tap this to reject him. He gets burned alive. It's the only language these men understand.",
    position: "top",
  },
  {
    target: ".like-btn",
    text: "Tap this to accept him. Questionable taste, but we don't judge.",
    position: "top",
  },
  {
    target: ".item-buttons",
    text: "Use these items for creative ways to get rid of him. Bazooka, lightsaber, kidnap van, or the thing they fear most — a YC rejection letter.",
    position: "left",
  },
  {
    target: ".pitch-panel",
    text: "This is his resume. Check his delusional startup metrics and red flags before making your decision.",
    position: "left",
    mobileTarget: ".mobile-resume-btn",
    mobileText: "Tap here to view his resume. Prepare to be underwhelmed.",
    mobilePosition: "top",
  },
];

export default function Tutorial({ onComplete }) {
  const [step, setStep] = useState(0);
  const [spotlight, setSpotlight] = useState(null);

  const updateSpotlight = useCallback(() => {
    const currentStep = STEPS[step];
    if (!currentStep) return;

    const isMobile = window.innerWidth <= 900;
    const selector = isMobile && currentStep.mobileTarget ? currentStep.mobileTarget : currentStep.target;
    const el = document.querySelector(selector);

    if (el) {
      const rect = el.getBoundingClientRect();
      setSpotlight({
        x: rect.left - 8,
        y: rect.top - 8,
        w: rect.width + 16,
        h: rect.height + 16,
        text: isMobile && currentStep.mobileText ? currentStep.mobileText : currentStep.text,
        position: isMobile && currentStep.mobilePosition ? currentStep.mobilePosition : currentStep.position,
      });
    } else {
      // Element not found, skip step
      if (step < STEPS.length - 1) {
        setStep(step + 1);
      } else {
        onComplete();
      }
    }
  }, [step, onComplete]);

  useEffect(() => {
    updateSpotlight();
    window.addEventListener("resize", updateSpotlight);
    return () => window.removeEventListener("resize", updateSpotlight);
  }, [updateSpotlight]);

  const handleNext = () => {
    if (step < STEPS.length - 1) {
      setStep(step + 1);
    } else {
      onComplete();
    }
  };

  if (!spotlight) return null;

  const isMobile = window.innerWidth <= 900;
  const vw = window.innerWidth;
  const vh = window.innerHeight;

  // Calculate tooltip position — on mobile, prefer bottom/top to avoid offscreen
  let tooltipStyle = {};
  const pad = 12;
  let pos = spotlight.position;

  // On mobile, override positions that would go offscreen
  if (isMobile) {
    if (pos === "right" || pos === "left") {
      pos = (spotlight.y + spotlight.h + 200 < vh) ? "bottom" : "top";
    }
    // For buttons near the bottom, always go above with enough clearance
    if (pos === "top" && spotlight.y > vh * 0.5) {
      pos = "top";
    }
  }

  if (pos === "right") {
    tooltipStyle = { left: Math.min(spotlight.x + spotlight.w + pad, vw - 296), top: spotlight.y + spotlight.h / 2, transform: "translateY(-50%)" };
  } else if (pos === "left") {
    tooltipStyle = { right: Math.min(vw - spotlight.x + pad, vw - 16), top: spotlight.y + spotlight.h / 2, transform: "translateY(-50%)" };
  } else if (pos === "top") {
    const tooltipWidth = isMobile ? 220 : 280;
    const centerX = spotlight.x + spotlight.w / 2;
    const left = Math.max(tooltipWidth / 2 + 8, Math.min(centerX, vw - tooltipWidth / 2 - 8));
    tooltipStyle = { left, top: spotlight.y - pad - 8, transform: "translate(-50%, -100%)" };
  } else if (pos === "bottom") {
    const left = Math.max(8, Math.min(spotlight.x + spotlight.w / 2, vw - 148));
    tooltipStyle = { left, top: spotlight.y + spotlight.h + pad, transform: "translateX(-50%)" };
  }

  return (
    <div className="tutorial-overlay" onClick={handleNext}>
      {/* Dark overlay with cutout */}
      <svg className="tutorial-mask" width="100%" height="100%">
        <defs>
          <mask id="tutorial-hole">
            <rect width="100%" height="100%" fill="white" />
            <rect
              x={spotlight.x}
              y={spotlight.y}
              width={spotlight.w}
              height={spotlight.h}
              rx="0"
              fill="black"
            />
          </mask>
        </defs>
        <rect width="100%" height="100%" fill="rgba(0,0,0,0.75)" mask="url(#tutorial-hole)" />
      </svg>

      {/* Spotlight border */}
      <div
        className="tutorial-spotlight"
        style={{
          left: spotlight.x,
          top: spotlight.y,
          width: spotlight.w,
          height: spotlight.h,
        }}
      />

      {/* Tooltip */}
      <div className="tutorial-tooltip" style={tooltipStyle} onClick={(e) => e.stopPropagation()}>
        <p className="tutorial-tooltip-text">{spotlight.text}</p>
        <div className="tutorial-tooltip-footer">
          <span className="tutorial-step-count">{step + 1} / {STEPS.length}</span>
          <button className="tutorial-next-btn" onClick={handleNext}>
            {step < STEPS.length - 1 ? "bruh" : "bruh"}
          </button>
        </div>
      </div>

      {/* Skip button */}
      <button className="tutorial-skip" onClick={(e) => { e.stopPropagation(); onComplete(); }}>
        Skip
      </button>
    </div>
  );
}
